export var VERSION = '2.17.8';
//# sourceMappingURL=version.js.map